import { render } from "./LifeCalendar.vue?vue&type=template&id=298093c8&scoped=true"
import script from "./LifeCalendar.vue?vue&type=script&lang=js"
export * from "./LifeCalendar.vue?vue&type=script&lang=js"

import "./LifeCalendar.vue?vue&type=style&index=0&id=298093c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298093c8"]])

export default __exports__